// const proxy = process.env.VUE_APP_QC_PROXY;
const qcApi = {
  GET_QR_CODE: '/addons/third/index/getqrcode',
  GET_LOGIN_STATUS: '/api/user/checkqrstatus',
  LOGIN_ACTION: '/api/user/login',
  GET_USER_INFO: '/api/user/index',
  GET_STORE_LIST: '/api/user/getStorelist', //获取店铺链接
  GET_QIANCHUAN_AUTH: '/api/Ju_liang/getAuth', //获取千川/随心推授权链接
  GET_QIAN_AUTH: '/api/qian/getAuth', //获取千川/随心推授权链接
  GET_DOUJIA_AUTH: '/api/Doujia/getAuth', //获取抖＋授权链接
  SYSN_AD_ACTION: '/api/Ju_liang/advertiserUp', //更新广告户数据
  GET_QIUANCHUAN_AD: '/api/Ju_liang/getAdvertiserList', //获取广告户列表

  GET_ALL_ADVERTISER: '/api/User/getAllAdvertiserListNew', //获取所有广告户列表

  GET_ALL_ADVERTISER_REPORT: '/api/User/getAllAdvertiserListReport', //获取所有广告户列表

  // GET_QIUANCHUAN_AD_GET:'/api/Ju_liang/getQianchuanAdGet',//获取指定广告户千川计划列表
  GET_QIUANCHUAN_AD_GET: '/api/Qc/getQcAdList', //获取指定广告户千川计划列表
  GET_QIUANCHUAN_MATERIAL_GET: '/api/Qc/getQcMaterialList', //获取指定广告户千川计划列表
  GET_QIUANCHUAN_MATERIAL_GET_NEW: '/api/Qc/getQcMaterialListNew', //获取指定广告户千川计划列表
  GET_QIUANCHUAN_MATERIAL_GET_QY: '/api/Qy/getQcMaterialListNew', //获取指定广告户千川计划列表
  STOP_QC_AD: '/api/Qc/stopOrderNew', //千川关停计划
  EDIT_QC_AD: '/api/Qc/editOrder', //千川修改计划

  GET_ADVERTISER_LIST: '/api/user/getAdvertiserList', //获取所有千川户列表
  GET_TASK_LIST: '/api/user/getTaskList', //获取随心推任务列表
  GET_TASK_DETAIL: '/api/User/task_detail', //随心推任务详情接口
  CANCEL_TASK: '/api/sxt/cancelTask', //取消随心推任务

  GET_SXT_WALLET: '/api/sxt/getSxtWallet', //更新随心推余额
  GET_QC_WALLET: '/api/qc/getQcWallet', //更新千川余额

  GET_QC_TASK_LIST: '/api/qc/getTaskList', //获取千川任务列表
  GET_QC_TASK_DETAIL: '/api/qc/task_detail', //千川任务详情接口
  CANCEL_QC_TASK: '/api/qc/cancelTask', //取消任务

  GET_QY_TASK_LIST: '/api/qy/getTaskList', //获取千川全域任务列表
  GET_QY_TASK_DETAIL: '/api/qy/task_detail', //千川全域任务详情接口
  CANCEL_QY_TASK: '/api/qy/cancelTask', //取消全域任务

  GET_SXT_AD_GET: '/api/Sxt/getSxtAdList', //获取指定广告户随心推计划列表
  GET_SXT_MONITOR_AD_GET: '/api/Sxt/getSxtMonitorAdList', //获取指定广告户随心推计划列表
  GET_QC_MONITOR_AD_GET: '/api/Qc/getQcMonitorAdList', //获取指定广告户千川计划列表
  GET_SXT_ADVERTISER_REPORT_GET: '/api/sxt/getadvertiserReportGet', //获取随心推账户数据
  GET_QC_ADVERTISER_REPORT_GET: '/api/qc/getadvertiserReportGet', //获取千川账户数据

  GET_QY_ADVERTISER_REPORT: '/api/qy/getAdvertiserReport', //获取全域账户数据

  GET_QY_AD_LIST: '/api/qy/getAdList', //获取全域计划列表
  GET_QY_AD_LIST_BY_LOAD: '/api/qy/getAdListByLoad', //多账户搜索计划列表

  GET_QY_BATCH_AD_LIST: '/api/qy/getBatchAdList', //获取全域计划列表

  GET_QY_AD_DETAIL: '/api/qy/getAdDetail', //获取全域计划详情
  STOP_QY_AD: '/api/qy/stopOrder', //关停计划
  EDIT_QY_AD: '/api/qy/editOrder', //千川修改计划
  EDIT_QY_AD_NEW: '/api/qy/editOrderNew', //千川修改计划
  EDIT_QY_AD_BATCH_NEW: '/api/qy/editOrderBatchNew', //千川修改计划

  GET_QY_ADVERTISER_REPORT_GET: '/api/qy/getAllAdvertiserReport', //获取全域账户数据
  GET_QC_ADVERTISER_REPORT_GET_ALL: '/api/qc/getAllAdvertiserReport', //获取全域账户数据
  
  // 积分返回明细相关接口
  GET_QC_SCORE_DETAIL: '/api/qc/getScoreDetail', //获取千川积分返回明细

  UPDATE_QY_ADVERTISER_REPORT: '/api/qy/updateAdvertiserReport', //更新全域账户数据

  STOP_SXT_AD: '/api/Sxt/stopOrder', //关停计划
  STOP_SXT_AD_DETAIL: '/api/Sxt/getOrderDetail', //计划订单详情接口

  QC_AD_DETAIL: '/api/Qc/getOrderDetail', //千川计划订单详情接口

  SXT_AWEME_VIDEO_GET: '/api/Sxt/qc_aweme_video_get', //抖音下视频列表
  QY_AWEME_VIDEO_GET: '/api/Qy/qc_aweme_video_get', //抖音下视频列表
  SXT_OTHER_VIDEO_GET: '/api/Sxt/getAwemeVideo', //抖音下视频列表(被投放人的视频)
  SXT_ADD_COPY_TASK: '/api/Sxt/add_copy_task', //新增複製視頻任務接口
  SXT_ADD_COPY_TASK_NEW: '/api/Sxt/add_copy_task_new', //新增複製視頻任務接口
  CREATE_SXT_VIDEO_TASK: '/api/Sxt/create_video_task', //创建随心推短视频计划接口
  CREATE_SXT_VIDEO_TASK_BATCH: '/api/Sxt/create_video_task_batch_new', //分批创建随心推短视频计划接口
  CREATE_SXT_LIVE_TASK: '/api/Sxt/create_live_task', //创建随心推短视频计划接口
  CREATE_SXT_LIVE_TASK_BATCH: '/api/Sxt/create_live_task_batch_new', //分批创建随心推直播计划接口

  ADD_USER_FEEDBACK: '/api/user/feedback', //意见反馈
  GET_SXT_REGION: '/api/user/getCity', //城市选择
  SXT_AWEME_NEAR_CREATE: '/api/user/getAwemeList', //近期投放号
  SXT_AWEME_NEAR_CREATE_NEW: '/api/user/getAwemeListNew', //近期投放号
  SXT_AWEME_NEAR_CREATE_LIVE: '/api/user/getAwemeListByLive', //近期投放号
  SXT_AUTHOR_GET: '/api/sxt/authorGet', //随心推推荐达人
  SXT_ADD_MONITOR: '/api/sxt/addmonitor', //新增监控
  SXT_ADD_AD_REMARK: '/api/sxt/add_ad_remark', //新增计划备注
  SXT_ADD_BATCH_REMARK: '/api/sxt/add_ad_remark_batch', //新增计划备注
  SXT_ADD_AD_WHITE: '/api/sxt/add_ad_white', //新增隨心推計劃白名單
  QC_ADD_AD_WHITE: '/api/qc/add_ad_white', //新增千川計劃白名單

  QY_ADD_AD_WHITE: '/api/qy/add_ad_white', //新增全域計劃白名單

  SXT_USER_LOGLIST: '/api/user/getSxtUserLogList', //新增监控

  SXT_SEARCH_VIDEO: '/api/sxt/searchVideo', //通过视频链接投放

  SXT_ADVERTISER_REPORT: '/api/user/getAdvertiserReport', //账户维度报表
  SXT_ADVERTISER_REPORT_DAY: '/api/sxt/getAdvertiserReportDay', //账户维度报表
  QC_ADVERTISER_REPORT_DAY: '/api/qc/getAdvertiserReportDay', //账户维度报表
  QY_ADVERTISER_REPORT_DAY: '/api/qy/getAdvertiserReportDay', //全域维度报表

  SXT_ADVERTISER_REPORT_ECHART: '/api/sxt/getAdvertiserReportEchart', //账户维度报表趋势
  SXT_AD_REPORT_ECHART: '/api/sxt/getAdReportEchart', //计划维度报表趋势
  QY_AD_REPORT_ECHART: '/api/qy/getAdReportEchart', //千川全域计划维度报表趋势

  SXT_VIDEO_LIVE_REPORT: '/api/user/getVideoLiveReport', //账户视频直播间维度报表

  GET_BID_LIMIT_SET: '/api/sxt/getBidLimitSet', //获取出价上限设置
  SET_BID_LIMIT: '/api/sxt/setBidLimit', //获取出价上限设置

  SXT_ADD_PRODUCT_COMMISSION: '/api/sxt/addProductCommission', //设置随心推商品佣金
  SXT_ADD_LIVE_COMMISSION: '/api/sxt/addLiveCommission', //设置随心推直播间佣金

  EDIT_QY_PRODUCT_COMMISSION: '/api/qy/addProductCommission', //设置全域商品佣金
  EDIT_QY_AWEME_DIVIDE_INTO_RATE: '/api/qy/setAwemeDivideIntoRate', //设置全域商品佣金

  SXT_ADD_ITEM_REMARK: '/api/sxt/addItemRemark', //设置随心推类目备注
  SXT_ADD_ITEM_FOLLOW: '/api/sxt/addItemFollow', //设置随心推类目关注

  SET_SXT_MONITOR: '/api/sxt/setMonitor', //设置随心推配置
  GET_SXT_MONITOR: '/api/sxt/getMonitorList', //设置随心推配置
  GET_SXT_MONITOR_LOG_LIST: '/api/sxt/getMonitorLogList', //监控日志
  GET_MONITOR_DETAIL: '/api/sxt/getMonitorDetail', //监控配置详情
  DELETE_SXT_MONITOR: '/api/sxt/delMonitor', //监控配置详情

  SET_QC_MONITOR: '/api/qc/setMonitor', //设置千川配置
  GET_QC_MONITOR: '/api/qc/getMonitorList', //设置千川配置
  GET_QC_MONITOR_LOG_LIST: '/api/qc/getMonitorLogList', //监控日志
  GET_QC_MONITOR_DETAIL: '/api/qc/getMonitorDetail', //监控配置详情
  DELETE_QC_MONITOR: '/api/qc/delMonitor', //监控配置详情

  SET_QY_MONITOR: '/api/qy/setQyMonitor', //设置千川配置


  SET_QY_MONITOR_BATCH: '/api/qy/setQyMonitorbatch', //设置千川配置

  GET_QY_MONITOR: '/api/qy/getQyMonitorList', //设置千川配置
  GET_QY_MONITOR_LOG_LIST: '/api/qy/getQyMonitorLogList', //监控日志
  GET_QY_MONITOR_DETAIL: '/api/qy/getQyMonitorDetail', //监控配置详情
  DELETE_QY_MONITOR: '/api/qy/delQyMonitor', //监控配置详情

  SET_QY_MATERIAL_MONITOR: '/api/qy/setQyMaterialMonitor', //设置千川配置
  GET_QY_MATERIAL_MONITOR: '/api/qy/getQyMaterialMonitorList', //设置千川配置
  GET_QY_MATERIAL_MONITOR_LOG_LIST: '/api/qy/getQyMaterialLogList', //监控日志
  GET_QY_MATERIAL_MONITOR_DETAIL: '/api/qy/getQyMaterialMonitorDetail', //监控配置详情
  DELETE_QY_MATERIAL_MONITOR: '/api/qy/delQyMaterialMonitor', //监控配置详情

  SXT_AWEME_AUTHORIZED: '/api/sxt/getAwemeAuthorized', //获取抖音号授权列表

  AWEME_ORDER_QUATO_GET: '/api/sxt/awemeOrderQuotaGet', //随心推配额查询

  AWEME_SUGGEST_BID_GET: '/api/sxt/awemeSuggestBid', //获取短视频建议出价

  AWEME_SUGGEST_RPI_GOAL_GET: '/api/sxt/awemeSuggestRoiGoal', //获取随心推ROI建议出价

  SEND_SXT_REPORT_GET: '/api/sxt/sendSxtReport', //定时获取随心推消耗数据

  SEND_QC_REPORT_GET: '/api/qc/sendQcReport', //定时获取千川消耗数据

  AWEME_ESTIMATE_PROFIT_GET: '/api/sxt/awemeEstimateProfit', //获取随心推投放效果预估

  DELETE_ADVERTISER: '/api/user/delete_advertiser', //解除授权

  UPDATE_ADVERSITER: '/api/user/updateAdvertiser', //更新户信息

  UPDATE_SXT_ADVERSITER: '/api/user/updateSxtAdvertiser', //更新户信息

  GET_QC_BID_LIMIT: '/api/qc/getBidLimit', //获取出价上限设置
  SET_QC_BID_LIMIT: '/api/qc/setBidLimit', //设置出价上限设置

  GET_PRODUCT_LIST: '/api/sxt/getProductReport', //商品汇总
  GET_PRODUCT_LIST_NEW: '/api/sxt/getProductReportNew', //商品汇总

  SET_SXT_TEMPLATE: '/api/sxt/addSxtTemp', //保存随心推模板

  GET_SXT_TEMPLATE: '/api/sxt/getSxtTemp', //获取随心推模板

  DEL_SXT_TEMPLATE: '/api/sxt/delTempAction', //删除随心推模板

  GET_USER_GROUP: '/api/user/getGroupList', //获取账户分组

  SET_USER_TEAM: '/api/user/setGroup', //设置账户分组

  GET_USER_TEAM_INFO: '/api/user/getGroupInfo', //获取账户分组详情

  DEL_USER_TEAM: '/api/user/delteGroupInfo', //删除账户分组详情

  GET_USER_GROUP_USER: '/api/user/getGroupUserList', //获取员工列表

  GET_DISTRIBUTION_USER: '/api/Distribution/getTeam', //获取下级

  GET_SXT_VIDEO_TIME: '/api/sxt/getvideotime', //获取随心推视频创建时间
  SXT_CALENDAR_REPORT: '/api/sxt/getCalendar', //随心推日历

  QC_CALENDAR_REPORT: '/api/qc/getCalendar', //千川日历

  QY_CALENDAR_REPORT: '/api/qy/getCalendar', //全域日历

  SEARCH_USER_BY_PHONE: '/api/user/searchPhone', //通过手机号获取用户

  SET_USER_GROUP_ACCOUNT: '/api/user/setUserGroupAccount', //保存设置

  DEL_USER_GROUP_ACCOUNT: '/api/user/delUserGroupAccount', //保存设置

  GET_SHARE_HB: '/api/user/getShareHb', //专属邀请海报

  GET_QC_INDUSTRY: '/api/qc/industryGet', //千川-获取行业分类
  GET_CAMPAIGN_LIST: '/api/qc/campaign_list_get', //千川-广告组列表
  // GET_QC_AWEME_LIST:'/api/qc/awemeAuthorizedGet',//千川-获取可投抖音号列表
  GET_QC_AWEME_LIST: '/api/qc/awemeAuthListGet', //千川-获取可投抖音号列表

  GET_QC_AWEME_LIST_QY: '/api/qy/awemeAuthListGetLocal', //千川-获取可投抖音号列表

  GET_QC_AWEME_LIST_QY_OLD: '/api/qy/awemeAuthListGet', //千川-获取可投抖音号列表

  GET_QC_AWEME_LIST_QY_NEW: '/api/qy/awemeAuthListGetNew', //千川-获取抖音号详情

  SET_CAMPAIGN_LIST: '/api/qc/campaignListCreate', //千川-创建广告组
  GET_QC_BID_SUGESST: '/api/qc/getSuggestBid', //获取千川建议出价
  GET_QC_ROI_SUGESST: '/api/qc/getSuggestRoi', //获取千川建议ROI

  GET_QC_PRODUCT_LIST: '/api/qc/productAvailable', //千川-获取抖音下商品
  GET_QC_PRODUCT_LIST_QY: '/api/qy/productAvailable', //千川-获取抖音下商品

  CREATE_QC_LIVE_TASK_BATCH: '/api/Qc/create_live_task_batch', //千川分批创建

  GET_DJ_AD_GET: '/api/Doujia/getAdList', //抖加-获取计划

  GET_VIDEO_COMMENT: '/api/sxt/toolsCommentGet', //获取评论列表

  ZT_SXT_AD: '/api/sxt/renewalOrder', //追投计划

  SXT_AD_DETAIL_REFELSH: '/api/sxt/refreshOrderDetail', //刷新计划详情

  GET_PRODUCT_DETAIL: '/api/product/getProductDetail', //商品详情

  GET_TASK_PLAN_LIST: '/api/sxt/getTaskPlanList', //获取随心推长期任务列表
  DEL_TASK_PLAN: '/api/sxt/delTaskPlan', //获取随心推长期任务列表
  UPDATE_TASK_PLAN: '/api/sxt/updateTaskPlan', //获取随心推长期任务列表

  QC_AWEME_VIDEO_GET: '/api/qc/qc_aweme_video_get_new', //千川抖音下视频
  QC_AWEME_VIDEO_GET_BATCH: '/api/qc/qc_aweme_video_get_batch', //千川抖音下视频
  QC_AWEME_VIDEO_GET_BATCH_TW: '/api/qc/qc_aweme_video_get_batch_tw', //千川抖音下视频

  CREATE_QC_TASK_PLAN: '/api/Qc/create_task_plan', //千川分批创建
  CREATE_QC_TASK_PLAN_NEW: '/api/Qc/create_task_plan_new', //千川分批创建(新版)
  CREATE_QY_TASK_PLAN_NEW: '/api/Qy/create_task_plan_new', //千川分批创建(新版)
  CREATE_QY_TASK_PLAN_NEW_MORE: '/api/Qy/create_task_plan_new_more', //千川分批创建(新版)

  QC_ADD_COPY_TASK: '/api/Qc/add_copy_task', //新增複製視頻任務接口
  QC_REFLESH_ALL_AD: '/api/Qc/releshAll', //刷新所有计划和报表
  GET_QC_TASK_PLAN_DETAIL: '/api/Qc/taskPreDetail', //任务详情

  QC_GET_VIDEO_BY_SCK: '/api/Qc/getVideoNew', //获取千川素材库素材
  QC_GET_VIDEO_BY_SCK_BATCH: '/api/Qc/qc_video_get_batch', //获取千川素材库素材
  QC_GET_IMAGE_BY_SCK: '/api/Qc/getImagesNew', //获取千川素材库素材
  QC_GET_NOTE_BY_SCK: '/api/Qc/getNoteNew', //获取千川素材库素材

  QC_GET_VIDEO_BY_SCK_NEW: '/api/Qc/getVideoSck', //获取千川素材库素材
  QC_SYSN_VIDEO_BY_SCK: '/api/Qc/sysnVideoNew', //同步所有计划和报表
  QC_SYSN_VIDEO_BY_SCK_DOWN: '/api/Qc/sysnVideoDown', //同步所有计划和报表

  QC_GET_LS_CONFIG: '/api/Qc/getConfig',
  GET_QIUANCHUAN_AD_TOTALITEM: '/api/Qc/getAdTotalItem',
  QC_UOLOAD_BY_LS_CLOUDE: '/api/Qc/uploadByLs',

  GET_QC_COMMENT_LIST: '/api/Qc/get_comment_list',
  REPLAY_COMMENT: '/api/Qc/replay_comment',
  HIDE_COMMENT: '/api/Qc/hide_comment',
  DO_TOP_COMMENT: '/api/Qc/stick_on_top',
  AWEME_BANNED: '/api/Qc/aweme_banned',
  GET_TERMS_LIST: '/api/Qc/get_terms_banned', //获取屏蔽词列表
  CHANGE_ADVERTISER_COMMENT: '/api/Qc/change_advertiser_comment', //开启控评
  DEL_ALL_BANNED: '/api/Qc/terms_banned_delete',
  ADD_ALL_BANNED: '/api/Qc/terms_banned_add',
  GET_BANNED_LOG_LIST: '/api/Qc/get_banned_log_list',

  GET_COMMENT_WRITE_LIST: '/api/Qc/get_comment_write_list',
  ADD_COMMENT_WRITE: '/api/Qc/add_comment_write',

  GET_QC_TASK_BATCH_LIST: '/api/Qc/getBatchTaskList',

  GET_QC_USER_VERIFICATION: '/api/User/getVerification',
  QC_SET_AD_BOOST: '/api/Qc/set_ad_boost',

  SXT_QC_AD_TREND: '/api/Qc/getQcAdTrend',
  SER_AD_COLUMNS: '/api/User/setAdColumns',
  QC_GET_AD_CBBZ: '/api/Qc/getQcAdCbbz',
  QC_GET_AD_LOGS: '/api/Qc/get_qc_log',
  COPY_QC_TASK: '/api/Qc/create_qc_task',
  SET_QC_TEMPLATE: '/api/Qc/setQcTemplate',
  GET_QC_TEMPLATE: '/api/Qc/getQcTemplate',
  GET_QC_TEMPLATE_LIST: '/api/Qc/getQcTemplateList',
  DEL_QC_TEMPLATE: '/api/Qc/delQcTemplate',

  //达人订单
  GET_KOL_ACCOUNT: '/api/douyin/getlist', //抖音号列表
  DEL_KOL_ACCOUNT: '/api/douyin/delaccount', //删除抖音号
  GET_KOL_ACCOUNT_LINK: '/api/douyin/get_link', //获取抖音号扫码
  GET_KOL_ACCOUNT_LINK_STATUS: '/api/douyin/get_link_status', //获取扫码结果
  GET_KOL_ALL_LIST: '/api/douyin/getAllList', //获取达人订单
  GET_KOL_ALL_CENCUS: '/api/douyin/getAllCencus', //获取达人订单汇总
  GET_KOL_RANK: '/api/douyin/getRank', //获取排行榜
  GET_KOL_STORE_LIST: '/api/douyin/storeList', //达人橱窗列表

  //抖+相关接口
  GET_DOUJIA_TASK_LIST: '/api/doujia/getTaskList', //抖+任务列表
  GET_DJ_ADVERTISER: '/api/Doujia/getAdvertiserList', //抖+-获取授权户
  GET_DJ_AWEME_VIDEO_GET: '/api/Doujia/qc_aweme_video_get', //抖音下视频列表
  CREATE_DJ_VIDEO_TASK_BATCH: '/api/Doujia/create_video_task_batch_new', //分批创建抖+短视频计划接口
  GET_DJ_TASK_DETAIL: '/api/Doujia/task_detail', //抖+任务详情接口
  CANCEL_DJ_TASK: '/api/Doujia/cancelTask', //取消任务

  //获取可授权户列表
  GET_AUTH_ADVERSITER: '/api/qian/getAuthAdversiter',
  CREATE_QIANCHUAN_AUTH: '/api/qian/createAdversiter',

  GET_QIAN_PRODUCT_LIST: '/api/qc/getProductList', //获取千川已推广商品列表

  GET_QY_SXT_PRODUCT_LIST: '/api/sxt_qy/getProductList', //获取千川已推广商品列表
  
  SXT_QY_AWEME_NEAR_CREATE: '/api/sxt_qy/getAwemeListNew', //近期投放号


  QC_GET_AD_MATERIAL: '/api/qc/getAdMaterial',

  QY_GET_AD_MATERIAL: '/api/qy/getAdMaterial',

  SXT_QY_GET_AD_MATERIAL: '/api/sxt_qy/getAdMaterial',

  GET_QY_AD_PRODUCT_LIST: '/api/qy/getAdProductList', //获取千川已推广商品列表

  GET_COURSOR_LIST: '/api/qc/getCoursorList', //获取投流学堂列表

  GET_QUESTION_LIST: '/api/qc/getQuestionList', //获取常见问题列表

  GET_QUESTION_DETAIL: '/api/qc/getQuestionDetail', //获取常见问题详情

  SEND_SMS_CODE: '/api/sms/send', //发送短信验证码

  RESET_USER_PWD: '/api/user/resetpwd', //重置密码

  PHONE_LOGIN: '/api/user/mobileloginnew', //验证码登录

  GET_INDEX_ECHART: '/api/user/getIndexEchart', //获取首页图表
  GET_INDEX_CIRCLE: '/api/user/getIndexCircle', //获取首页图表

  GET_TOOL_LIST: '/api/index/getToolList', //获取首页图表
  ADD_TOOL_BOX: '/api/index/addToolBox', //获取首页图表
  DEL_TOOL_BOX: '/api/index/delToolBox', //获取首页图表

  GET_ACCOUNT_LIST: '/api/qian/getAccountList', //获取已授权账户列表

  GET_ACCOUNT_ADVERTISER: '/api/qian/getAccountAdversiter', //获取已授权账户列表

  ADD_AUTH_ADVERSITER: '/api/qian/addAuthAdversiter', //获取已授权账户列表

  CLICK_TOOL_BOX: '/api/index/clickToolBox', //点击工具

  GET_MATERIAL_CATEGORY_TREE: '/api/material/getCategoryTree', //获取文件夹分类树
  GET_MATERIAL_CATEGORY_LIST: '/api/material/getCategoryList', //获取文件夹列表
  ADD_MATERIAL_CATEGORY: '/api/material/addCategory', //新增文件夹
  DEL_MATERIAL_CATEGORY: '/api/material/delCategory', //删除文件夹

  GET_MATERIAL_ATTACHMENT_LIST: '/api/material/getAttachmentList', //获取素材列表
  ADD_MATERIAL_ATTACHMENT: '/api/material/addAttachment', //新增素材
  DEL_MATERIAL_ATTACHMENT: '/api/material/delAttachment', //删除素材

  EDIT_MATERIAL_ATTACHMENT: '/api/material/editAttachment', //编辑素材
  EDIT_MATERIAL_CATEGORY: '/api/material/editCategory', //编辑文件夹

  GET_DOUYIN_SCAN_AUTH: '/api/auth/createQrcode', //获取抖音扫码授权链接
  GET_DOUYIN_SCAN_AUTH_STATUS: '/api/auth/getQrcodeStatus', //获取抖音扫码授权链接

  STOP_QY_AD_MATERIAL: '/api/qy/deleteQyMaterial',

  DEL_QY_AD_PRODUCT: '/api/qy/deleteQyProduct',

  GET_SXT_HISTORY_AWEME: '/api/sxt/getHistoryAwemeList',

  SXT_VIDEO_LIVE_REPORT_OTHER: '/api/sxt/getOtherReport',

  QC_ADD_AD_REMARK: '/api/qc/add_ad_remark', //新增千川计划备注
  QC_ADD_BATCH_REMARK: '/api/qc/add_ad_remark_batch', //新增千川计划备注

  QY_ADD_AD_REMARK: '/api/qy/add_ad_remark', //新增千川计划备注applyQyAweme
  QY_EDIT_AD_NAME: '/api/qy/edit_ad_name', //新增千川计划备注
  QY_ADD_BATCH_REMARK: '/api/qy/add_ad_remark_batch', //新增千川计划备注

  SET_QY_QC_COOKIE: '/api/qy/setCookie', //设置cookie
  GET_QY_AWEME_LIST_BYQC: '/api/qy/getAwemeList', //获取达人

  
  GET_QY_AWEME_LIST_BYQC_NEW: '/api/qy/getAwemeListNew', //获取达人

  APPLY_QY_AWEME: '/api/qy/applyQyAweme', //申请达人

  
  APPLY_QY_AWEME_GF: '/api/qy/applyQyAwemeGf', //申请达人

  APPLY_QY_AWEME_SHOP: '/api/qy/listTrailerProductShop',

  APPLY_QY_AWEME_SHOP_GF: '/api/qy/listTrailerProductShopGf',

  APPLY_QY_AWEME_SHOP_NEW: '/api/qy/listTrailerShop',

  //店铺下千川户
  GET_STORE_ADVERSITER: '/api/user/getStoreAdversiter',

  GET_MONITOR_REPLY_LIST: '/api/user/get_monitor_reply_list',
  SET_MONITOR_REPLY: '/api/user/set_monitor_reply',
  DEL_MONITOR_REPLY: '/api/user/del_monitor_reply',
  GET_MONITOR_REPLY_LOG_LIST: '/api/user/get_monitor_reply_log_list',

  QY_AWEME_ADD_DOUYIN: '/api/qy/applyDouyinNew',
  UPDATE_QC_AD: '/api/qc/adUpdate',

  GET_TOOLS_APPLY_ACCOIUNT: '/api/tools/getAccount',
  DEL_TOOLS_APPLY_ACCOIUNT: '/api/tools/delAccount',
  SET_TOOLS_DY_COOKIE: '/api/tools/setCookie',

  UPDATE_TOOS_AUTO:'/api/tools/setCookieAuto',

  TOOLS_AWEME_ADD_DOUYIN: '/api/tools/applyDouyin',
  TOOLS_QY_AWEME_LIST_BYQC: '/api/tools/getAwemeList', //获取达人
  TOOLS_APPLY_QY_AWEME_SHOP: '/api/tools/listTrailerProductShop',
  TOOLS_APPLY_QY_AWEME: '/api/tools/applyQyAweme', //申请达人

  ZHUANTOU_QY_AD: '/api/qy/zhuantou',

  GET_KOL_PRODUCT_COST_RADIO: '/api/qy/getProductCostRadio', //获取达人商品佣金比例

  GET_QY_WHITE_AD_GET: '/api/qy/getWhiteAdList', //获取监控广告白名单

  RETRY_QY_TASK: '/api/qy/retryTask', //重试任务

  RETRY_QC_TASK: '/api/qc/retryTask', //重试任务
  
  ADD_QY_AD_MATERIAL: '/api/qy/addAdMaterial', //计划内追加素材
  ADD_QY_AD_LIVE_MATERIAL: '/api/qy/addAdLiveMaterial', //直播计划内追加素材

  ADD_QC_AD_MATERIAL: '/api/qc/addAdMaterial', //计划内追加素材

  GET_SC_UPLOAD_LIST: '/api/qy/getScUploadList',

  MOVE_MATERIAL_ATTACHMENT: '/api/Material/moveFile',

  GET_TEAM_USER_LIST: '/api/user/getTeamUserList',

  GET_KS_ADVERTISER: '/api/Ks/getAdvertiserList', //获取所有广告户列表
  GET_KUAISHOU_AUTH: '/api/ks/getAuth', //获取快手授权链接
  SET_KS_MONITOR: '/api/ks/setMonitor', //设置快手配置
  GET_KS_MONITOR: '/api/ks/getMonitorList', //设置快手配置
  GET_KS_MONITOR_LOG_LIST: '/api/ks/getMonitorLogList', //监控日志
  GET_KS_MONITOR_DETAIL: '/api/ks/getMonitorDetail', //监控配置详情
  DELETE_KS_MONITOR: '/api/ks/delMonitor', //监控配置详情

  GET_TOOLS_COMFIRM_LIST: '/api/tools/getToolsConfirmList',
  COMFIRM_PROM_AUTH: '/api/tools/comfirmPromAuth',

  GET_SXT_QY_ADVERTISER_REPORT: '/api/sxt_qy/getAdvertiserReport', //获取全域账户数据
  GET_SXT_QY_AD_LIST: '/api/sxt_qy/getAdList', //获取全域计划列表
  GET_SXT_QY_AD_DETAIL: '/api/sxt_qy/getAdDetail', //获取全域计划详情
  STOP_SXT_QY_AD: '/api/sxt_qy/stopOrder', //关停计划
  EDIT_SXT_QY_AD: '/api/sxt_qy/editOrder', //千川修改计划
  SEND_QY_SXT_REPORT_GET: '/api/sxt_qy/sendSxtReport', //定时获取随心推消耗数据
  QY_SXT_AD_DETAIL_REFELSH: '/api/sxt_qy/refreshOrderDetail', //刷新计划详情
  ZT_QY_SXT_AD: '/api/sxt_qy/renewalOrder', //追投计划

  SET_QY_SXT_MONITOR: '/api/sxt_qy/setQyMonitor', //设置千川配置
  GET_QY_SXT_MONITOR: '/api/sxt_qy/getQyMonitorList', //设置千川配置
  GET_QY_SXT_MONITOR_LOG_LIST: '/api/sxt_qy/getQyMonitorLogList', //监控日志
  GET_QY_SXT_MONITOR_DETAIL: '/api/sxt_qy/getQyMonitorDetail', //监控配置详情
  DELETE_QY_SXT_MONITOR: '/api/sxt_qy/delQyMonitor', //监控配置详情
  GET_QY_SXT_WHITE_AD_GET: '/api/sxt_qy/getWhiteAdList', //获取监控广告白名单
  QY_SXT_ADD_AD_WHITE: '/api/sxt_qy/add_ad_white', //新增全域計劃白名單
  CREATE_QY_SXT_TASK_PLAN_NEW: '/api/sxt_qy/create_task_plan_new', //全域随心推分批创建(新版)

  GET_QY_SXT_TASK_LIST: '/api/sxt_qy/getTaskList', //获取千川全域任务列表
  GET_QY_SXT_TASK_DETAIL: '/api/sxt_qy/task_detail', //千川全域任务详情接口
  CANCEL_QY_SXT_TASK: '/api/sxt_qy/cancelTask', //取消全域任务
  SXT_QY_AD_REPORT_ECHART: '/api/sxt_qy/getAdReportEchart', //计划维度报表趋势

  GET_QC_AWEME_LIST_QY_SXT: '/api/sxt_qy/awemeAuthListGet', //千川-获取可投抖音号列表
  GET_QC_PRODUCT_LIST_QY_SXT: '/api/sxt_qy/productAvailable', //千川-获取抖音下商品
  STOP_QY_SXT_AD: '/api/sxt_qy/stopOrder', //关停计划

  QY_SXT_ADD_COPY_TASK_NEW: '/api/sxt_qy/add_copy_task_new', //新增複製視頻任務接口
  QY_SXT_BUDGET_SUGGEST_GET: '/api/sxt_qy/budgetSuggestGet',
  QY_SXT_ROI_SUGGEST_GET: '/api/sxt_qy/roiSuggestGet',
  // GET_SXT_MONITOR:'/api/sxt/getMonitorList',//设置随心推配置
  // GET_SXT_MONITOR_LOG_LIST:'/api/sxt/getMonitorLogList',//监控日志

  QY_GET_SUGGEST_ORDER: '/api/qy/getSuggestOrder',

  GET_COMMENT_MONITOR_LIST: '/api/comment/getMonitorList', //获取评论监控列表
  SET_COMMENT_MONITOR: '/api/comment/setMonitor', //设置评论监控
  DEL_COMMENT_MONITOR: '/api/comment/delMonitor', //获取评论监控
  GET_COMMENT_MONITOR_DETAIL: '/api/comment/getMonitorDetail', //获取评论监控详情

  GET_COMMENT_WRITE_WORDS_LIST: '/api/comment/get_write_words', //获取白名单配置
  SET_COMMENT_WRITE_WORDS: '/api/comment/set_write_words', //设置白名单配置
  DEL_COMMENT_WRITE_WORDS: '/api/comment/del_write_words', //删除白名单配置

  GET_MONITOR_REPLY_LIST_NEW: '/api/comment/get_monitor_reply_list',

  ADD_DOUYIN_STORE: '/api/douyin/storeAdd',

  GET_QY_AUTO_CREATE_LIST: '/api/qy/getAutoConfigList', //获取自动创建计划配置列表
  SET_QY_AUTO_CREATE: '/api/qy/setAutoConfig', //设置自动创建计划配置
  DEL_QY_AUTO_CREATE: '/api/qy/delAutoConfig', //删除自动创建计划配置
  GET_QY_AUTO_CREATE_DETAIL: '/api/qy/getAutoConfigDetail', //获取自动创建计划配置详情
  EDIT_QY_AUTO_CREATE: '/api/qy/editAutoConfig', //修改自动创建计划配置

  EDIT_QY_AUTO_CREATE_BATCH: '/api/qy/editAutoConfigBatch', //修改自动创建计划配置

  
  GET_QY_AUTO_CREATE_LOG_LIST: '/api/qy/getAutoCreateLogList',
  GET_QY_AUTO_CREATE_CENCUS: '/api/qy/getAutoCreateCencus',
  GET_QY_AUTO_CREATE_CENCUS_NO: '/api/qy/getAutoCreateCencusNo',


  
  GET_QY_BLACK_PRODUCT_LIST: '/api/product/get_black_list', //获取商品黑名单列表
  ADD_QY_BLACK_PRODUCT: '/api/product/add_black', //添加商品黑名单  
  DEL_QY_BLACK_PRODUCT: '/api/product/del_black', //删除商品黑名单


  
  GET_FISSION_MONITOR_LIST: '/api/fission/getMonitorList', //获取裂变监控列表
  SET_FISSION_MONITOR: '/api/fission/setMonitor', //设置裂变监控
  DEL_FISSION_MONITOR: '/api/fission/delMonitor', //获取裂变监控
  GET_FISSION_MONITOR_DETAIL: '/api/fission/getMonitorDetail', //获取裂变监控详情

  
  SET_ROITK_MONITOR: '/api/roitk/setMonitor', //设置ROI监控
  GET_ROITK_MONITOR_LIST: '/api/roitk/getMonitorList', //获取ROI监控列表
  DEL_ROITK_MONITOR: '/api/roitk/delMonitor', //获取ROI监控详情
  GET_ROITK_MONITOR_DETAIL: '/api/roitk/getMonitorDetail', //获取ROI监控详情


  REMOVE_QC_ADVERSITER: '/api/Qc/removeAdversiter', //解除千川授权


  GET_QY_CJ_LOG_LIST: '/api/qy/getCjLogList', //获取重建日志列表
  REBUILD_QY_AD: '/api/qy/rebuildOrder', //重建计划

  ADD_QY_PRODUCT: '/api/qy/addProduct', //补商品

  GET_QY_CJ_ERROR_COUNT: '/api/qy/getCjErrorCount', //获取当日重建失败数量

  
  GET_ADVERSITER_GROUP: '/api/qy/getAdversiterGruop', //获取千川户分组列表
  ADD_ADVERSITER_GROUP: '/api/qy/addAdversiterGruop', //设置千川户分组
  DEL_ADVERSITER_GROUP: '/api/qy/delAdversiterGruop', //删除千川户分组 
  EDIT_ADVERSITER_GROUP: '/api/qy/editAdversiterGruop', //编辑千川户分组 
  


  GET_FORBIDDEN_WORDS: '/api/qy/get_forbidden_words', //获取违规词列表
  EDIT_FORBIDDEN_WORDS: '/api/qy/edit_forbidden_words', //编辑违规词列表



  GET_QY_SUGGEST_ROI: '/api/qy/qySuggestRoi', //获取推荐ROI

  FISION_MATERIAL: '/api/qy/fissionMaterial', //裂变素材


  GET_QY_FISSION_LOG_LIST: '/api/qy/getFissionLogList', //获取裂变日志列表

  GET_QY_FISSION_LOG_DETAIL: '/api/qy/getFissionLogDetail', //获取裂变日志详情



  GET_QY_PRODUCT_REPORT: '/api/qy/getProductReport', //获取商品报表
  GET_QY_AWEME_REPORT: '/api/qy/getAwemeReport', //获取抖音号报表

  EXPORT_QY_PRODUCT_REPORT: '/api/qy/exportProductReport', //导出商品报表


  UPDATE_DOUYIN_ACCOUNT_INFO: '/api/douyin/updateDyAccount', //更新抖音号信息

  UPDATE_DOUYIN_DIVIDE_INTO_RATE: '/api/douyin/updateDyDivideIntoRate', //更新抖音号分成比


  GET_PRODUCT_COMMISSION_RATE: '/api/product/get_commision', //获取商品佣金比例


  GET_AD_ROI_EDIT_TIME: '/api/qy/getAdRoiEditTime', //获取广告计划ROI修改时间

  SYSN_ADVERSITER_ORDER: '/api/qy/syncAdversiterOrder', //同步广告计划订单

  
  CREATE_ONE_QY_AD: '/api/Qy/create_one_ad', //全域检测单个素材是否能创建计划

  GET_SC_PRODUCT_LIST: '/api/wanlshop/product/getScList', //选品广场-爆款商品列表
  GET_SC_PRODUCT_DETAIL: '/api/wanlshop/product/getScDetail', //选品广场-商品素材详情
  SC_CLAIM_AND_PUBLISH: '/api/wanlshop/product/scClaimPublish', //选品广场-领取并发布素材


  
  GET_QY_AD_CONTROL_LIST: '/api/qy/getAdControlList', //获取广告计划调控列表
  UPDATE_QY_AD_CONTROL_STATUS: '/api/qy/updateAdControlStatus', //更新广告计划调控状态

  CREATE_QY_AD_CONTROL_TASK: '/api/qy/createAdControlTask', //创建广告计划调控任务
  
  GET_LIVED_MATERIAL: '/api/qy/getLivedMaterial', //获取直播间画面素材ID

};

export { qcApi };
